import * as d3 from 'd3'
export default {
  methods: {

    draw_Summary(selection, props) {

      selection
      .append('text')
      .attr('id', `TITLE_${props.idx}`)
      .attr('x', 0) .attr('y', this.title.y)
      .attr('font-size', this.title.main.tSize).attr('fill', this.title.main.tdor)
      .text(props.name)

      selection
      .append('text')
      .attr('x', this.getNode(`#TITLE_${props.idx}`) + 5) .attr('y', this.title.y)
      .attr('font-size', this.title.sub.tSize).attr('fill', this.title.sub.tColor)
      .text(this.punch + ' Punch')



      let bar = selection
      .append('g')
      .attr('transform', `translate(${this.summary.x + .5}, ${this.summary.y + .5})`)

      let created = props.thisWeek.CR_CUM
      let closed  = props.thisWeek.CL_CUM
      let active  = props.thisWeek.ACTIVE

      let barLen = 0
      if(!(created == 0 || active == 0)) barLen = 200 * (active/created)

      bar
      .append('rect')
      .attr('x', 0).attr('y', 0).attr('rx', 3)
      .attr('width', 200).attr('height', 6)
      .attr('fill', '#E0E0DF').attr('stroke-width', 0)
      .attr('opacity', .5)

      bar
      .append('rect')
      .attr('x', 0).attr('y', 0).attr('rx', 3)
      .attr('width', barLen).attr('height', 6)
      .attr('fill', '#F7BACF').attr('opacity', .7)

      // ACTIVE
      bar
      .append('text')
      .attr('x', 1).attr('y', -11)
      .attr('fill', '#F35E90').attr('font-size', 14)
      .attr('text-anchor', 'start')
      .text(active)
      .call(this.event_Link, props.thisWeek, this.summary.status.find(f=> f.code=='ACTIVE'))

      bar
      .append('text')
      .attr('x', 2).attr('y', -2)
      .attr('fill', '#F7BACF').attr('font-size', 9)
      .attr('text-anchor', 'start')
      .text(this.summary.status.find(f=> f.code=='ACTIVE').name)


      // CREATED
      bar 
      .append('text')
      .attr('x', 140).attr('y', -21 + 9*0.75)
      .attr('fill', '#757575').attr('font-size', 9)
      .attr('text-anchor', 'end')
      .text('Created')

      bar 
      .append('text')
      .attr('x', 140).attr('y', -12 + 12*0.75)
      .attr('fill', '#333').attr('font-size', 12)
      .attr('text-anchor', 'end')
      .text(created)
      .call(this.event_Link, props.thisWeek, this.summary.status.find(f=> f.code=='CR_CUM'))

      // CLOSED
      bar 
      .append('text')
      .attr('x', 198).attr('y', -21 + 9*0.75)
      .attr('fill', '#757575').attr('font-size', 9)
      .attr('text-anchor', 'end')
      .text('Closed')

      bar 
      .append('text')
      .attr('x', 198).attr('y', -12 + 12*0.75)
      .attr('fill', '#333').attr('font-size', 12)
      .attr('text-anchor', 'end')
      .text(closed)
      .call(this.event_Link, props.thisWeek, this.summary.status.find(f=> f.code=='CL_CUM'))
 

    },



  }
}